<div class="modal-header" id="confirmation-material-stock-modal-title">
    <h3
        class="modal-title"
        [translate]="
            isBootStockFromSideMenu
                ? 'CONFIRMATION_MATERIAL_STOCK_TITLE_BOOT_STOCK'
                : 'CONFIRMATION_MATERIAL_ADDITIONAL_MATERIAL'
        "
    ></h3>
    <span class="close" (click)="modalInstance.hide()">&times;</span>
</div>
<div class="modal-body" id="modal-body">
    <form class="confirmationMaterialAddStockForm" [formGroup]="confirmationMaterialStockForm">
        <fieldset formArrayName="formChildren">
            <div class="container-fluid">
                <div class="row mb-3 align-items-center">
                    <label
                        class="col-12 fw-bold text-start p-0"
                        for="materialNumber"
                        [translate]="'CONFIRMATION_MATERIAL_CSE_STOCK_MATNO'"
                    ></label>
                    <div class="col-12 p-0 mb-3">
                        <pace-core-text-input
                            id="materialNumber"
                            [(model)]="model.materialNumber"
                            [parentForm]="confirmationMaterialStockFormChildren"
                            (valueChange)="validateForm()"
                            [ariaLabel]="'CONFIRMATION_MATERIAL_CSE_STOCK_MATNO' | translate"
                        ></pace-core-text-input>
                    </div>
                    @if (isBootStockFromSideMenu) {
                        <label
                            class="col-12 fw-bold text-start p-0"
                            for="materialDescription"
                            [translate]="'CONFIRMATION_MATERIAL_CSE_STOCK_MATERIAL_DESCRIPTION'"
                        ></label>
                        <div class="col-12 mb-3 mb-lg-0 p-0">
                            <pace-core-text-input
                                id="materialDescription"
                                [(model)]="model.materialDescription"
                                (valueChange)="validateForm()"
                                [parentForm]="confirmationMaterialStockFormChildren"
                                [ariaLabel]="'CONFIRMATION_MATERIAL_CSE_STOCK_MATERIAL_DESCRIPTION' | translate"
                            ></pace-core-text-input>
                        </div>
                    } @else {
                        <label
                            class="col-12 fw-bold text-start p-0"
                            for="storageLocation"
                            [translate]="'CONFIRMATION_MATERIAL_CSE_STOCK_STORAGE_LOCATION'"
                        ></label>
                        <div class="col-12 p-0 d-flex w-100">
                            <pace-core-text-input
                                id="storageLocation"
                                [(model)]="model.storageLocation"
                                [parentForm]="confirmationMaterialStockFormChildren"
                                (valueChange)="validateForm()"
                                class="flex-grow-1"
                                [ariaLabel]="'CONFIRMATION_MATERIAL_CSE_STOCK_STORAGE_LOCATION' | translate"
                            ></pace-core-text-input>
                            @if (activeTab === MatStockTab.OTHER_STOCK) {
                                <button
                                    id="btnStockSearch"
                                    type="button"
                                    class="btn btn-primary ms-2"
                                    translate="CONFIRMATION_MATERIAL_CSE_STOCK_SEARCH"
                                    [disabled]="isSearchInProgress || isBootStockLoading"
                                    (click)="searchStock()"
                                ></button>
                            }
                        </div>
                    }
                </div>
                @if (isBootStockFromSideMenu ? model.cseMaterialStocks.length > 0 : !isBootStockLoading) {
                    <div class="row mb-2 material-stock-content">
                        <div class="col-12">
                            @if (isBootStockFromSideMenu) {
                                <pace-confirmation-material-stock-details
                                    [materialsList]="filteredBootStock"
                                    [isBootStock]="true"
                                    [showBootStockActions]="true"
                                    [isModelNotification]="!!model.notification"
                                    (bootStockReturnSuccess)="modalInstance.hide()"
                                ></pace-confirmation-material-stock-details>
                            } @else {
                                <tabset #tabSet type="pills" paceCoreTabsRole>
                                    <tab
                                        [heading]="'CONFIRMATION_MATERIAL_LABEL_BOOT_STOCK' | translate"
                                        (selectTab)="onTabSelected(MatStockTab.BOOT_STOCK)"
                                    >
                                        <pace-confirmation-material-stock-details
                                            [materialsList]="filteredBootStock"
                                            [isBootStock]="true"
                                            [isModelNotification]="!!model.notification"
                                            (bootStockReturnSuccess)="modalInstance.hide()"
                                        ></pace-confirmation-material-stock-details>
                                    </tab>
                                    <tab
                                        [heading]="'CONFIRMATION_MATERIAL_LABEL_OTHER_STOCK' | translate"
                                        (selectTab)="onTabSelected(MatStockTab.OTHER_STOCK)"
                                    >
                                        <pace-confirmation-material-stock-details
                                            [materialsList]="model.otherStock"
                                            [bootStock]="model.bootStock"
                                            [isBootStock]="false"
                                            [isModelNotification]="!!model.notification"
                                            (smartLockerPickup)="pickupFromStock()"
                                            (switchToBootStock)="switchToBootStockTab()"
                                        ></pace-confirmation-material-stock-details>
                                    </tab>
                                </tabset>
                            }
                        </div>
                    </div>
                }
            </div>
        </fieldset>
    </form>
</div>
<ng-template>
    <div class="d-flex justify-content-center align-items-center p-4">
        <progressbar [value]="100" class="w-100">
            <span translate="BOOTSTOCK_RETURN_LOADING"></span>
        </progressbar>
    </div>
</ng-template>

<div class="modal-footer" id="modal-footer">
    @if (isBootStockLoading) {
        <progressbar [value]="100" type="info">
            <span translate="CONFIRMATION_MATERIAL_LABEL_BOOT_STOCK_LOADING"></span>
        </progressbar>
    } @else if (isSearchInProgress) {
        <progressbar [value]="100" type="info">searching...</progressbar>
    } @else if (isPickupInProgress) {
        <progressbar [value]="100" type="info">picking up...</progressbar>
    }
    @if (model.notification && !isBootStockLoading && !isSearchInProgress && !isPickupInProgress) {
        <button
            type="button"
            class="btn btn-primary col-12 col-md-4 col-lg-2"
            [disabled]="!isMaterialSelected()"
            (click)="pickupFromStock()"
            translate="CONFIRMATION_MATERIAL_CSE_STOCK_LABEL_PICKUP"
        ></button>
    }
</div>
